export default __webpack_public_path__ + "static/media/menuL_on_icon_05.b259c6bd.png";